import { Controller } from 'stimulus'

export default class extends Controller {
  showTranslationForm (e) {
    e.preventDefault()
    const { target } = e
    target.nextElementSibling.classList.toggle('afd-hide')
  }
}
